// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Uhmm","col":"styles_col__V2gtk"};